export const ALL_TYPES_FILTER_VALUE = 'all';
export const ALL_TYPES_FILTER_NAME = 'All Types';
export const SUPPORT_CHECKS_FILTER_VALUE = 'support_checks';
export const SUPPORT_CHECKS_FILTER_NAME = 'Support Checks';

export const ADMIN_CHECK_TYPE_MULTI_SELECT_NORMALIZE = {
  allValue: ALL_TYPES_FILTER_VALUE,
  allName: ALL_TYPES_FILTER_NAME,
  exclusiveValue: SUPPORT_CHECKS_FILTER_VALUE,
  exclusiveName: SUPPORT_CHECKS_FILTER_NAME,
};

export const CLIENT_CHECK_TYPE_MULTI_SELECT_NORMALIZE = {
  allValue: ALL_TYPES_FILTER_VALUE,
  allName: ALL_TYPES_FILTER_NAME,
};

export const isTruthyDbBool = value => value === true || value === 1 || value === '1';

const sortByName = (a, b) =>
  (a.name ?? '').localeCompare(b.name ?? '', undefined, { sensitivity: 'base' });

export function buildCheckTypeFilterOptions(
  checkTypes,
  { includeSupportChecks = false, excludeDeprecated = true } = {},
) {
  const types = (checkTypes || [])
    .filter(ct => {
      if (!excludeDeprecated || ct == null || !('deprecated' in ct)) return true;
      return !isTruthyDbBool(ct.deprecated);
    })
    .map(ct => ({
      name: ct.title ?? ct.name,
      value: ct.slug ?? ct.value,
    }))
    .filter(opt => opt.value)
    .sort(sortByName);

  return [
    { name: ALL_TYPES_FILTER_NAME, value: ALL_TYPES_FILTER_VALUE },
    ...(includeSupportChecks
      ? [{ name: SUPPORT_CHECKS_FILTER_NAME, value: SUPPORT_CHECKS_FILTER_VALUE }]
      : []),
    ...types,
  ];
}
